module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/nickAndNatalieInvite-2047dcba8ca106ec3659bb6a2fef6a85.jpg";